import { useState } from 'react'
import Dataprofile from './dataProfile'
import Profile from './index'
import Passwordprofile from './passwordProfile'
const MainProfile = () => {
  const [tabs, setTabs] = useState<number>(1)
  return (
    <div className="c-page-profile">
      <div className="c-page-profile__body">
        <div className="c-page-profile__container-tab">
        {/*   <span className={`c-page-profile__tab ${tabs === 0 && `c-page-profile__tab--active`}`} onClick={() => setTabs(0)}>
            Overview
          </span> */}
          <span className={`c-page-profile__tab ${tabs === 1 && `c-page-profile__tab--active`}`} onClick={() => setTabs(1)}>
          Personal Information
          </span>
          <span className={`c-page-profile__tab ${tabs === 2 && `c-page-profile__tab--active`}`} onClick={() => setTabs(2)}>
            Password
          </span>
        </div>
      {/*  {
          tabs === 0 && <Dataprofile setting={() => setTabs(1)}/>
        } */}
        {
          tabs === 1 && <Profile />
        }
        {
          tabs === 2 && <Passwordprofile/>
        }
      </div>
    </div>
  )
}

export default MainProfile